import { ReoIcon } from '@reolink-web/components.basic';
import React from 'react';
import actionStyles from '../index.module.less';
import styles from './index.module.less';
import CompNavCart from '@/components/NavCart';
import { HeaderContext } from '@/components/ReolinkHeader/common';
import classNames from 'classnames';
import { getOfficialSitePath } from '@/utils/function/sitePath';
const CompHeaderCart: React.FC = () => {
    const { lang } = React.useContext(HeaderContext);

    const [productQuantity, setProductQuantity] = React.useState<number>(0);

    return (
        <li className={ classNames(actionStyles['header-action-item'], styles['header-action-item-cart']) }>
            <ReoIcon
                className={ classNames(actionStyles['header-action-item-icon'], styles['header-action-item-cart-icon']) }
                name={ 'icon-icon_cart-2' }
            />
            <a
                className={ styles['header-action-item-link'] }
                href={ getOfficialSitePath('/cart/') }>
                <ReoIcon
                    className={ classNames(
                        actionStyles['header-action-item-icon'],
                        styles['header-action-item-cart-icon'],
                    ) }
                    name={ 'icon-icon_cart-2' }
                />
            </a>
            {productQuantity > 0 && <span className={ styles['cart-quantity-badge'] }>{productQuantity}</span>}
            <div className={ styles['dropdown-cart-content'] }>
                <CompNavCart
                    onCartUpdate={ setProductQuantity }
                    lang={ lang } />
            </div>
        </li>
    );
};
export default CompHeaderCart;
